import { render, staticRenderFns } from "./SelectGoods.vue?vue&type=template&id=37020f42&scoped=true"
import script from "./SelectGoods.vue?vue&type=script&lang=js"
export * from "./SelectGoods.vue?vue&type=script&lang=js"
import style0 from "./SelectGoods.vue?vue&type=style&index=0&id=37020f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37020f42",
  null
  
)

export default component.exports